var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _vm.task
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "2" } },
                [
                  _c("v-progress-circular", {
                    attrs: { size: "64", color: "primary", indeterminate: "" },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                [
                  _vm.isPredict
                    ? _c(
                        "h2",
                        { staticClass: "page-title page-title__primary" },
                        [_vm._v("Идет расчет прогноза")]
                      )
                    : _c(
                        "h2",
                        { staticClass: "page-title page-title__primary" },
                        [_vm._v("Идет адаптация модели")]
                      ),
                  _c("p", [_vm._v(_vm._s(_vm.statusText))]),
                  _c("p", [
                    _vm._v("Шаг " + _vm._s(_vm.innerTask.step_number || 0)),
                  ]),
                  _vm.task.status === "error"
                    ? _c("v-alert", { attrs: { type: "error" } }, [
                        _vm._v(
                          _vm._s(_vm.innerTask.error || "Неизвестная ошибка")
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "v-row",
            [
              _c("v-col", [
                _vm._v(
                  ' Расчетная задача пока не создана. Перейдите в раздел "Настройки" '
                ),
              ]),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }